import { render, staticRenderFns } from "./permision.vue?vue&type=template&id=2ba853e4&scoped=true&"
import script from "./permision.vue?vue&type=script&lang=ts&"
export * from "./permision.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba853e4",
  null
  
)

export default component.exports